<template>
  <div class="w-100">
    <main class="w-100">
      <LoadingSpinner v-if="!completeLoading" />
      <div v-else>
        <div class="col-12 px-0">
          <h4>Email Answers</h4>
          <div
            class="container-fluid w-100 mb-3 p-3 border  bg-white rounded stats-wrapper"
          >
            <div class="d-flex flex-wrap">
              <!-- FILA 1 -->
              <div class="w-50 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >From</span
                  >
                </div>
              <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="filters.range.startDate"
                  :config="datePickerConfig"
                  placeholder="Start Date"
                ></date-picker>
                   <!-- DATE TO -->
                   <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >to</span
                  >
                </div>
                <date-picker
                  id="endDatePicker"
                  class="form-control"
                  v-model="filters.range.endDate"
                  :config="datePickerConfigEndDate"
                  placeholder="End Date"
                ></date-picker>
                </div>
  
              <!-- SENT FROM -->
              <div class="w-50 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >From</span
                  >
                </div>
                <input
                  id="startDatePicker"
                  class="form-control"
                  v-model="filters.sent_from"
                  placeholder="Email"
                />
  
                <!-- SENT TO -->
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >to</span
                  >
                </div>
                <input
                  id="endDatePicker"
                  class="form-control"
                  v-model="filters.sent_to"
                  placeholder="Email"
                />
              </div>
  
              <!-- FILA 2 -->
              <!-- BDR -->
              <div
                class="w-50 input-group input-group-sm p-1 treeselect-wrapper"
                v-if="['1','9'].includes(currentUser.role_id)"
              >
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >BDR</span
                  >
                </div>
                <treeselect
                  v-model="filters.bdrUserFilter"
                  :options="bdrUserOptions"
                  :normalizer="normalizeOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div>
  
              <!-- FILA 3 --> 
 
  
              <!-- FILTER TEMPERATURE -->
              <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >{{ $t("lang.label.filter-temperature_status") }}</span
                  >
                </div>
                <treeselect
                  v-model="filters.temperatureStatusFilter"
                  :options="temperatureStatuseOptions"
                  :multiple="true"
                  class="form-control inline-table"
                >
                </treeselect>
              </div> 

              <div class="w-25 p-1 ml-auto">
                <div class="col-md-12 d-flex justify-content-end my-2">
                  <button
                    class="btn btn-success"
                    :disabled="!completeLoading"
                    @click="getBdrAnswerEmailList()"
                  >
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-12 w-100 mb-3 card p-2">
          <div v-if="completeLoading && total > 0" class="row">
            <div class="col-12">
              <div class="bd-highlight">
                {{ $t("lang.label.results") }}:
                <small v-if="!total" class="ml-1 text-primary"
                  >{{ $t("lang.search.calculating") }}...</small
                >
                <strong v-else>{{ total }}</strong>
                <button class="ml-2 btn btn-sm btn-primary" 
                  @click="getToDownload()"
                  :disabled="processingAllItems"
                  >
                  <span v-if="!processingAllItems">
                    Download csv
                  </span>
                  <span v-else>Processing...</span>
                </button>
              </div>
              <div class="text-center mb-2">
                <Pagination
                  :total="total"
                  :totalpage="bdrTaskListQty"
                  :model="pagination"
                  :limit="false"
                  :color="'primary'"
                  @changePage="getBdrAnswerEmailList"
                  key="paginationkey"
                ></Pagination>
              </div>
            </div>
          </div>
    
          <div class="col-12 px-0 mx-0 table-responsive">
            <Table
              :key="3232323"
              :headers="simpleheader"
              :cols="simplecols"
              :data="list"
              :checkbox="false"
              :notselect="true"
              :model="[]"
              @goToOpportunity="goToOpportunity"
              @goToAgency="goToAgency"
              @viewConversation="onViewConversation"
            >
            </Table>
          </div>
        </div>
      </div>
    </main>
    <EmailHistory
      modal-name="bdr-answer-emails-conversation"
      :client="emailHistoryClient"
      :emails="emailHistoryEmails"
      :visible="emailHistoryVisible"
      :loading="emailHistoryLoading"
      @close="onEmailHistoryClose"
    />
  </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import { adminService, notificationService, usersService } from "@/_services";
  import Table from "@/components/Common/Table.vue";
  import Pagination from "@/components/Common/Pagination.vue";
  import EmailHistory from "@/components/Common/EmailHistory.vue";
  import moment from "moment";
  import Treeselect from "@riophae/vue-treeselect";
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import { statusBadgeMixin } from "@/_mixins/";
  
  export default {
    name: "BdrAnswerEmails",
    components: { Table, Pagination, LoadingSpinner, Treeselect, EmailHistory },
    props: {
      condition: {
        type: String,
        default: "all",
      },
      targetId: {
        type: String,
        default: '0'
      }
    },
    mixins: [statusBadgeMixin],
    computed: {
      capitalizeFirstLetter() {
        return (word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        };
      },
    },
    data() {
      return {
        emailHistoryVisible: false,
        emailHistoryLoading: false,
        emailHistoryEmails: [],
        emailHistoryClient: null,
        processingAllItems: false,
        withMeetingOptions: [
          { id: 1, label: this.$t("lang.button.yes") },
          { id: 0, label: this.$t("lang.label.no") },
        ],
        completeLoading: false,
        total: 10,
        pagination: {
          imported: false,
          refreshlist: false,
          selectfirst: false,
          cantPerPage: 25,
          currentPage: 1,
        },
        list: [],
        listAllItems: [],
        bdrUserOptions: [],
        taskStatuses: [
          {
            id: "1",
            label: "Todo",
          },
          {
            id: "2",
            label: "Done",
          },
        ],
        taskTypeOptions: [
          {
            id: "coldphoning",
            label: this.$t("lang.task.callcontact_title"),
          },
          {
            id: "manualanswer",
            label: this.$t("lang.task.manualanswer_title"),
          },
          {
            id: "reminder",
            label: "Reminder Task",
          },
          {
            id: "absent",
            label: "Absent Event",
          },
          {
            id: "calendar",
            label: "Calendar activity with no event",
          },
          {
            id: "cancelled",
            label: "Cancelled Event",
          },
        ],
        temperatureStatuseOptions: [
          {
            id: "1",
            label: "Urgent",
          },
          {
            id: "2",
            label: "Positive",
          },
          {
            id: "3",
            label: "Introduction",
          },
          {
            id: "4",
            label: "Wrong contact",
          },
          {
            id: "5",
            label: "Negative",
          },
          {
            id: "6",
            label: "Calendar inspection",
          },
          {
            id: "7",
            label: "Reschedule",
          },
          {
            id: "8",
            label: "Cold",
          },
          {
            id: "9",
            label: "Other Answer",
          },
        ],
        oppStatusOptions: [
          {
            id: "canceled",
            label: "Canceled",
          },
          {
            id: "absent",
            label: "Absent",
          },
          {
            id: "on",
            label: "On",
          },
          {
            id: "off",
            label: "Off",
          },
        ],
        domainhttpsindex: 32322332,
        lastFilters: [],
        filters: {
          sent_from:'',
          sent_to:'',
          taskStatusFilter: [],
          bdrUserFilter: [],
          taskTypeFilter: [],
          oppStatusFilter: [],
          temperatureStatusFilter: [],
          targetId: this.targetId,
          withMeeting: [],
          range: {
            startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        },

        // Answer date

        // Booker

        // From (email del que envia)

        // To (email del que recibe)	

        // Recipent name (nombre apellido del que recibe)

        // Opportunity

        // Client

        // Opportunity temperature


        simpleheader: [
          {
            label: this.$t("lang.column.creationdate"),
            class: "overflowhide",
          },
          {
            label: "Booker",
            class: "overflowhide",
          },
          {
            label: "From",
            class: "overflowhide",
          },
          {
            label: "To",
            class: "overflowhide",
          },
          {
            label: "Recipent name",
            class: "overflowhide",
          },          
          {
            label: "Opportunity ID",
            class: "overflowhide",
          },
          {
            label: "Opportunity",
            class: "overflowhide",
          },
          {
            label: "Client",
            class: "overflowhide",
          },
          {
            label: "Opportunity Temperature",
            class: "overflowhide",
          },
          {
            label: "Conversation",
            class: "overflowhide",
          },
        ],
        simplecols: [
          [
            {
              value: "created",
              class: "text-primary",
            },
          ],
          [
            {
            value: "booker",
            class: "text-primary",
            },
          ],
          [
            {
            value: "sent_from",
            class: "text-primary",
            },
          ],
          [
            {
            value: "sent_to",
            class: "text-primary",
            },
          ],
          [
            {
            value: "recipent_name",
            class: "text-primary",
            },
          ],
          [
            {
              value: "link_id",
            },
          ],
          [
            {
              value_label: "business_name",
              value_emit: "link_id",
              class: "text-primary",
              type: "emit",
              emit: "goToOpportunity",
            },
          ],
          [
            {
              value_label: "client_name",
              value_emit: "client_id",
              class: "text-primary",
              type: "emit",
              emit: "goToAgency",
            },
          ],
          [
            {
              value: "link_status_temperature_id",
              type: "itemBadge",
              class: "badge badge-primary",
              colors: [
                {
                  id: 1,
                  label: "Urgent",
                  bgColor: "#008000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 2,
                  label: "Positive",
                  bgColor: "#008000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 3,
                  label: "Introduction",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 4,
                  label: "Wrong Contact",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 5,
                  label: "Negative",
                  bgColor: "#0000FF",
                  textColor: "#FFFFFF",
                },
                {
                  id: 6,
                  label: "Calendar Inspection",
                  bgColor: "#00FFFF",
                  textColor: "#000000",
                },
                {
                  id: 7,
                  label: "Reschedule",
                  bgColor: "#FFFF00",
                  textColor: "#000000",
                },
                {
                  id: 8,
                  label: "Cold",
                  bgColor: "#000000",
                  textColor: "#FFFFFF",
                },
                {
                  id: 9,
                  label: "Other Answer",
                  bgColor: "#FF9966",
                  textColor: "#000000",
                },
              ],
            },
          ],
          // [
          //   {
          //     value: "calification",
          //     type: "itemBadge",
          //     class: "badge",
          //     colors: [
          //       {
          //         id: "new_meeting",
          //         label: "New meeting",
          //         bgColor: "#28a745",
          //         textColor: "#FFFFFF",
          //         tooltipRowField: "calification_response",
          //       },
          //       {
          //         id: "rescheduled_meeting",
          //         label: "Rescheduled meeting",
          //         bgColor: "#fd7e14",
          //         textColor: "#FFFFFF",
          //         tooltipRowField: "calification_response",
          //       },
          //       {
          //         id: "no_meeting",
          //         label: "No meeting",
          //         bgColor: "#6c757d",
          //         textColor: "#FFFFFF",
          //         tooltipRowField: "calification_response",
          //       },
          //     ],
          //   },
          // ],
          [
            {
              type: "btnIfNotNull",
              value_if: "created",
              btnId: "id",
              emit: "viewConversation",
              name: "View conversation",
            },
          ],
        ],
        datePickerConfig: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          // minDate: moment().startOf("day")
          maxDate: moment().endOf("day"),
        },
        datePickerConfigEndDate: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          maxDate: moment().endOf("day"),
        },
      };
    },
    created() {
      this.getUserBdr();
      this.getBdrAnswerEmailList();
    },
    computed: {
      bdrTaskListQty() {
        return this.list.length;
      },
      ...mapState({
        currentUser: (state) => state.authentication.user,
      }),
    },
    methods: {
      normalizeCalification(raw) {
        if (raw === null || raw === undefined || raw === "") {
          return "empty";
        }
        const s = String(raw).trim().toLowerCase();
        const compact = s.replace(/\s+/g, "_");
        if (
          s === "new meeting" ||
          compact === "new_meeting" ||
          s === "1" ||
          s === "newmeeting"
        ) {
          return "new_meeting";
        }
        if (
          s === "rescheduled meeting" ||
          compact === "rescheduled_meeting" ||
          s === "2" ||
          (s.includes("reschedule") && s.includes("meeting"))
        ) {
          return "rescheduled_meeting";
        }
        if (
          s === "no meeting" ||
          compact === "no_meeting" ||
          s === "3" ||
          s === "nomeeting"
        ) {
          return "no_meeting";
        }
        return "empty";
      },

      getToDownload() {
        const allItems = 1; // cuando quieres pedir todos los resultados sin limite
        this.getBdrAnswerEmailList(allItems);
      },

      download() {   

        const nameDocument = "report-list-answers-email.csv";

        //Tomo headers desde simpleheader
        const headers = this.simpleheader.map(h => h.label);

        const fields = this.simplecols.map( item => {
          const value = (item[0].value) ? item[0].value : item[0].value_label;
          return value;
        })

        const rows = this.listAllItems.map( item => {
          return fields.map( col => {
            return item[col];
          }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
        })

        const csv = `${headers.join(",")}\n${rows.join("\n")}`;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", nameDocument);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        },
      isBdrUser() {
        if (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2) {
          this.bdr_user_id = this.currentUser.id;
          return true;
        } else {
          return false;
        }
      },
      getUserBdr() {
        if (this.isBdrUser()) {
          return false;
        }
        // this.selectUserBdr = false
        usersService
          .getBdrs()
          .then((res) => {
            this.bdrUserOptions = res.result;
            // this.selectUserBdr = true
          })
          .catch((err) => consolelog(err));
      },
      normalizeOptions(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      getBdrAnswerEmailList(allItems = 0) {
        if (JSON.stringify(this.filters) != JSON.stringify(this.lastFilters)) {
          this.getBdrAnswerEmailTotal();
        }
  
        // const taskOutputList = [
        //   "Meeting Booked",
        //   "Call back",
        //   "No answer",
        //   "No phone",
        //   "No interest",
        // ];
  
        
        let filters = this.filters;
        filters.cantPerPage = this.pagination.cantPerPage;
        filters.currentPage = this.pagination.currentPage;
        filters.getTotal = 0;
        filters.allItems = allItems;
        if(allItems != 1){
          this.completeLoading = false;
        } else {
          this.processingAllItems = true;
        }
        notificationService.getBdrAnswersEmail(filters).then((result) => {
          if (result) {
            if(allItems === 1){
              this.listAllItems = result.map( el => ({
                ...el,
                link_status_temperature_id: (el.link_status_temperature_id) ? el.link_status_temperature_id : 'empty',
                calification: this.normalizeCalification(el.calification),
              }));
              this.download()
              this.processingAllItems = false;
            } else {
              this.list = result.map( el => ({
                ...el,
                link_status_temperature_id: (el.link_status_temperature_id) ? el.link_status_temperature_id : 'empty',
                calification: this.normalizeCalification(el.calification),
              }));
            }
            
            // this.list.forEach((item) => {
            //   item.task_type = this.getTaskTypeTitle(item.task_type);
            //   item.task_output = (item.task_output != null) ? taskOutputList[item.task_output - 1] : 'empty';             
            // });
          } else {
            this.notifications = [];
            this.total = 0;
          }
          this.lastFilters = JSON.parse(JSON.stringify(this.filters));
          this.completeLoading = true;
        });
      },
      getBdrAnswerEmailTotal() {
        this.pagination.currentPage = 1;
        this.total = 0;
        let filters = this.filters;
        filters.cantPerPage = this.pagination.cantPerPage;
        filters.currentPage = this.pagination.currentPage;
        filters.getTotal = 1;
        notificationService.getBdrAnswersEmail(filters).then((result) => {
          this.total = result.total;
        });
      },
      goToOpportunity(link_id) {
        window.open("/opportunities/" + link_id, "_blank");
      },
  
      goToAgency(client_id) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      },

      onViewConversation(id) {
        const item = this.list.find((el) => el.id == id);
        if (!item) {
          return;
        }
        const { sent_to, link_id } = item;
        if (!link_id || !String(sent_to || "").trim()) {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: "Missing link or recipient email for this row.",
            showConfirmButton: true,
          });
          return;
        }

        this.emailHistoryClient = item.client_name
          ? { client_name: item.client_name }
          : null;
        this.emailHistoryEmails = [];
        this.emailHistoryVisible = true;
        this.emailHistoryLoading = true;

        adminService
          .getLinkEmailMessages(link_id, sent_to)
          .then((rows) => {
            this.emailHistoryEmails = Array.isArray(rows) ? rows : [];
          })
          .catch((err) => {
            this.emailHistoryEmails = [];
            const msg =
              err && err.message
                ? err.message
                : this.$t("lang.label.error");
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: msg,
              showConfirmButton: true,
            });
          })
          .finally(() => {
            this.emailHistoryLoading = false;
          });
      },

      onEmailHistoryClose() {
        this.emailHistoryVisible = false;
        this.emailHistoryEmails = [];
        this.emailHistoryClient = null;
      },
  
      getTaskTypeTitle(title) {
        if (title.indexOf("lang.") !== -1) {
          let message = JSON.parse(title);
          return this.$t(message.lang_message);
        }
        return title;
      },
    },
  };
  </script>
  